const META_PIXEL_ID = '957775904033427';

const FACEBOOK_NODE_RE = /facebook\.com|facebook\.net|fbcdn\.net|fbevents/i;

export function isAdminPath(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
    return pathname === '/admin' || pathname.startsWith('/admin/');
}

function noopPixel() {
    const noop = function noop() {};
    noop.callMethod = noop;
    noop.queue = [];
    noop.q = [];
    noop.loaded = true;
    noop.version = '2.0';
    noop.push = noop;
    return noop;
}

function isFacebookNode(el) {
    if (!el || el.nodeType !== 1) return false;
    const src = `${el.getAttribute?.('src') || el.src || ''} ${el.getAttribute?.('id') || ''} ${el.getAttribute?.('name') || ''}`;
    return FACEBOOK_NODE_RE.test(src);
}

/** Drop fbevents.js, tracking pixels, and CSP-error iframes that parse 183KB of Chrome HTML each. */
export function stripFacebookTrackingNodes(root = typeof document !== 'undefined' ? document : null) {
    if (!root) return 0;
    let removed = 0;
    const nodes = root.querySelectorAll('iframe, script, img');
    for (let i = 0; i < nodes.length; i += 1) {
        const el = nodes[i];
        if (!isFacebookNode(el)) continue;
        try {
            el.remove();
            removed += 1;
        } catch (_) { /* ignore */ }
    }
    return removed;
}

function installAdminPixelGuard() {
    if (typeof window === 'undefined' || window.__statboxAdminPixelGuard) return;
    window.__statboxAdminPixelGuard = true;
    stripFacebookTrackingNodes();
    window.setInterval(() => {
        if (isAdminPath()) stripFacebookTrackingNodes();
    }, 2000);
}

/** Marketing pixels must not hook Video Analysis / admin controls. */
export function disableAdminMarketingPixels() {
    if (typeof window === 'undefined' || !isAdminPath()) return;
    try {
        const fbq = window.fbq;
        if (typeof fbq === 'function') {
            try { fbq('set', 'autoConfig', false, META_PIXEL_ID); } catch (_) { /* ignore */ }
        }
        window.fbq = noopPixel();
        window._fbq = window.fbq;
        window.oaiq = noopPixel();
    } catch (_) { /* ignore */ }
    stripFacebookTrackingNodes();
    installAdminPixelGuard();
}
